
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[locale]/coaches",
      function () {
        return require("private-next-pages/[region]/[locale]/coaches.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[locale]/coaches"])
      });
    }
  